<template>
    <button type="button" :class="{ 'site-dropdown': true, 'is-open-list': isOpenList }" @click.prevent="toggleList">
        <span v-html="label"></span>

        <icon-base viewBox="0 0 14 8" class="site-dropdown__arrow"><icon-arrow-down /></icon-base>

        <div class="site-list site-dropdown__list">
            <ul class="site-list__inner">
                <li class="site-list__item" v-for="(item, index) in siteList" :key="item.id">
                    <a :href="item.link" class="site-list__link">
                        <p class="site-list__title" v-html="item.title"></p>
                        <p class="site-list__description" v-html="item.description"></p>
                    </a>
                </li>
            </ul>
        </div>
    </button>
</template>

<script>
export default {
    data() {
        return {
            isOpenList: false,
        }
    },
    methods: {
        toggleList(e) {
            this.isOpenList = !this.isOpenList;
        },
        closeList(e) {
            if (!this.$el.contains(e.target)) {
                this.isOpenList = false;
            }
        },
    },
    props: {
        label: {
            type: String,
            default: 'Другие сайты НСК',
        },
        siteList: {
            type: Array,
            required: true,
        }
    },
    mounted() {
        document.addEventListener('click', this.closeList);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeList);
    }
}
</script>
